import React, { FunctionComponent } from 'react';

import AboutOwner from '../AboutOwner/AboutOwner';
import PageList from '../PageList/PageList';

interface AboutCampaignProps {
  campaigns: {
    logo: string;
    title: string;
    url: string;
    summary?: string | null;
    id: string;
    branding?: {
      logo?: string | null;
    };
    charities: {
      name: string;
      url: string;
    }[];
  }[];
}

const AboutCampaign: FunctionComponent<AboutCampaignProps> = ({
  campaigns,
}) => {
  if (campaigns.length === 1) {
    const campaign = campaigns[0];

    const campaignLogo = campaign.branding?.logo ?? campaign.logo;

    const charity =
      campaign.charities && campaign.charities.length === 1
        ? campaign.charities[0]
        : undefined;

    return (
      <AboutOwner
        logo={campaignLogo || null}
        name={campaign.title}
        parentOwnerName={(charity && charity.name) || undefined}
        parentOwnerUrl={(charity && charity.url) || undefined}
        ownerUrl={campaign.url}
        description={campaign.summary || ''}
      />
    );
  }
  if (campaigns.length > 1) {
    return (
      <PageList
        pages={campaigns.map(x => ({
          url: x.url,
          logo: x.logo || '',
          campaignId: x.id,
          title: x.title,
        }))}
      />
    );
  }
  return null;
};

export default AboutCampaign;
